import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
const OnboardingStep2 = ({
  onNext,
  userData,
  setUserData
}) => {
  const [temperatureBias, setTemperatureBias] = useState(userData.temperatureBias || null);
  const biasOptions = [{
    value: 'cold',
    label: 'I usually run cold',
    description: 'I get cold easily and prefer more layers',
    emoji: '🥶'
  }, {
    value: 'neutral',
    label: 'I\'m usually comfortable',
    description: 'Standard recommendations work well for me',
    emoji: '😊'
  }, {
    value: 'warm',
    label: 'I usually run warm',
    description: 'I get warm easily and prefer fewer layers',
    emoji: '🥵'
  }];
  const handleNext = () => {
    if (temperatureBias) {
      setUserData(prev => ({
        ...prev,
        temperatureBias
      }));
      onNext();
    }
  };
  return <div className="bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl shadow-xl p-6 border border-gray-200 dark:border-gray-700">
      <div className="text-center mb-6">
        <h2 className="text-h2 text-foreground mb-2">Clothing Preference</h2>
        <p className="text-body-sm text-muted-foreground">
          Do you generally run warm or cold?
        </p>
      </div>
      
      <div className="space-y-3">
        {biasOptions.map(option => <button key={option.value} onClick={() => setTemperatureBias(option.value)} className={`w-full p-4 rounded-lg border-2 transition-all text-left group hover:scale-[1.02] ${temperatureBias === option.value ? 'border-blue-500 bg-blue-50 dark:bg-blue-900/20 shadow-lg' : 'border-gray-200 dark:border-gray-600 hover:border-gray-300 dark:hover:border-gray-500 hover:bg-gray-50 dark:hover:bg-gray-700/50'}`}>
            <div className="flex items-center">
              <span className="text-2xl mr-3">{option.emoji}</span>
              <div className="flex-1">
                <div className="text-label text-foreground">
                  {option.label}
                </div>
                <div className="text-body-sm text-muted-foreground mt-1">
                  {option.description}
                </div>
              </div>
              {temperatureBias === option.value && <div className="text-primary ml-2">
                  ✓
                </div>}
            </div>
          </button>)}
      </div>

      <Button onClick={handleNext} disabled={!temperatureBias} className="w-full mt-6 bg-blue-500 hover:bg-blue-600 dark:bg-blue-600 dark:hover:bg-blue-700 text-white font-medium py-3 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed rounded-3xl">
        Next →
      </Button>
    </div>;
};
export default OnboardingStep2;